export default "__VITE_ASSET__fb6b47a4__"